module.exports = __webpack_public_path__ + "img/logo.1a9415b5.png";